import React, {useEffect} from 'react';
import useApi from '../../../utility/Hooks/Api/useApi';
import DefaultSelect from '../Default/DefaultSelect';
import CustomSelect from '../Custom/CustomSelect';
import {ElectronicHousingUnitApi} from "../../../services/Api/ElectronicHousingUnitApi";

export default function ElectronicHousingUnitSelect({onChange, label, required}) {
    const {request, data} = useApi();

    useEffect(() => {
        request(ElectronicHousingUnitApi.getElectronicHousingUnits())
    }, []);

    const ehuOptions = (e) => {
        return data.map((ehu) => ({value: JSON.stringify(ehu), label: `${ehu["id"]} - ${ehu["productType"]} - ${ehu["productCode"]}`}));
    };

    return (
        <>
            <CustomSelect
                options={data ? ehuOptions() : []}
                placeHolder={`Select a Electronic Housing Unit`}
                onChange={(e) => onChange(e)}
                isSearchable
            />
        </>
    )
}